import React, { Component } from "react";
import { connect } from 'react-redux';
import { Col, Row, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { checkBoxSelect } from "../Pages/actions";
import { DisplayFlex } from "../../../CommonComponents/commonStyles";
import {
  SeparatorBorder,
  ListViewUnderlineLink,
  PrimaryIndicatorDocument,
  ListMobileWrapper,
  ListViewDate,
  ListComponentWrapper,
  MainListWrapper,
  MobileListContainer,
  FlexCenter
} from './styles';
import moment from "moment";
import { milliToDate, docNameFormatter } from "../../../utils/commonUtil";
import { getPrimaryAccount } from "../../../utils/sessionUtil";
import { downloadFileFromUrl } from '../../../services/apiServices';
export class ListViewDocument extends Component {
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checkbox !== this.props.checkbox) {
      if (nextProps.checkbox !== null) {
        if (nextProps.checkbox) {
          this.updateSelectedData();
        } else {
          this.removeSelectedData();
        }
      }
    }
  }

  downLoadFile(docId) {

    let url = `/donor-portal/api/account/${getPrimaryAccount().userId}/getAccountDocumentsByAccountIdAndDocId?docId=${docId}`;

    downloadFileFromUrl(url);

  }

  updateSelectedData() {
    let selectedFiles = this.props.selectedFiles;
    selectedFiles[this.props.eachId].foreach(each => (each.selected = true));
    let selectedCheckBoxArray = this.props.selectedLinks
      ? this.props.selectedLinks
      : [];
      
    let totalData = this.props.arrayData[this.props.eachId][1];
    if (selectedCheckBoxArray.length > 0) {
      for (let i = (selectedCheckBoxArray.length - 1); i >= 0; i--) {
        if (selectedCheckBoxArray[i]["gridIndex"] === this.props.eachId) {
          selectedCheckBoxArray.splice(i, 1);
        }
      }
    }
    for (let i = 0; i < totalData.length; i++) {
      selectedCheckBoxArray.push({
        gridIndex: this.props.eachId,
        indexVal: i,
        accordionName: this.props.docVal[0],
        name: totalData[i]["name"],
        link: totalData[i]["link"],
        date: totalData[i]["date"]
      });
    }
    this.props.checkBoxChange({ "selected": selectedCheckBoxArray, selectedFiles });
  }

  removeSelectedData() {
    let selectedFiles = this.props.selectedFiles;
    selectedFiles[this.props.eachId].foreach(each => (each.selected = false));
    let selectedCheckBoxArray = this.props.selectedLinks
      ? this.props.selectedLinks
      : [];
    if (selectedCheckBoxArray.length > 0) {
      for (let i = (selectedCheckBoxArray.length - 1); i >= 0; i--) {
        if (selectedCheckBoxArray[i]["gridIndex"] === this.props.eachId) {
          selectedCheckBoxArray.splice(i, 1);
        }
      }
    }
    this.props.checkBoxChange({ "selected": selectedCheckBoxArray, selectedFiles });
  }

  render() {
    let docVal = this.props.docVal[1];
    const startDate = moment().format("MM-DD-YYYY");
    return (
      <Row data-test="document-list-view">
        {
          docVal && docVal.map((each, index) => {
            {
              if (index < 6)
                return (
                  <MainListWrapper key={`show-less-${index}`}>
                    <Col lg={{ span: 11, offset: ((index % 2) !== 0) ? 1 : 0 }} xs={{ span: 0 }} className={(docVal.length % 2 === 0) ? "listClassEven" : "listClassOdd"}>
                      <ListComponentWrapper>
                        <ListViewDate>{milliToDate(each.date)}</ListViewDate>
                        <Tooltip placement="topLeft" title={docNameFormatter(each.name)}>
                          
                          {(each.docId > 0 && each.uploadedByVC === true) ?


                            <ListViewUnderlineLink data-test='list-view' marginLeft='20px' onClick={() => { this.downLoadFile(each.docId) }} >{docNameFormatter(each.name)}</ListViewUnderlineLink>

                            :

                            <ListViewUnderlineLink marginLeft='20px' href={each.link} target="_blank">{docNameFormatter(each.name)}</ListViewUnderlineLink>



                          }
                        </Tooltip>
                        {
                          ((moment(startDate, 'MM-DD-YYYY').diff(moment(each.Date, 'MM-DD-YYYY'), 'days')) > 0 && (moment(startDate, 'MM-DD-YYYY').diff(moment(each.date, 'MM-DD-YYYY'), 'days')) <= 7) ?
                            <PrimaryIndicatorDocument>
                              new
                             </PrimaryIndicatorDocument>
                            : ''
                        }
                      </ListComponentWrapper>
                    </Col>
                    <Col lg={{ span: 0 }} xs={{ span: 24 }}>
                      <ListMobileWrapper>
                        <FlexCenter>
                          <MobileListContainer>
                            <ListViewDate>{milliToDate(each.date)}</ListViewDate>
                            {
                              ((moment(startDate, 'MM-DD-YYYY').diff(moment(each.date, 'MM-DD-YYYY'), 'days')) > 0 && (moment(startDate, 'MM-DD-YYYY').diff(moment(each.date, 'MM-DD-YYYY'), 'days')) <= 7) ?
                                <PrimaryIndicatorDocument>
                                  new
                             </PrimaryIndicatorDocument>
                                : ''
                            }
                            <DisplayFlex>
                              {(each.docId > 0 && each.uploadedByVC === true) ?


                                <ListViewUnderlineLink onClick={() => { this.downLoadFile(each.docId) }} >{docNameFormatter(each.name)}</ListViewUnderlineLink>

                                :


                                <ListViewUnderlineLink href={each.link} target="_blank">{docNameFormatter(each.name)}</ListViewUnderlineLink>


                              }
                              
                            </DisplayFlex>
                          </MobileListContainer>
                        </FlexCenter>
                      </ListMobileWrapper>
                    </Col>
                    {((index + 1) % 3 === 0) ? <SeparatorBorder /> : <div />}
                    {(index % 2 !== 0) ? <br /> : <div />}
                  </MainListWrapper>
                )
              else if (this.props.showMore) {
                return (
                  <MainListWrapper key={`show-more-${index}`}>
                    <Col lg={{ span: 11, offset: ((index % 2) !== 0) ? 1 : 0 }} xs={{ span: 0 }} className={(docVal.length % 2 === 0) ? "listClassEven" : "listClassOdd"}>
                      <ListComponentWrapper>

                        <ListViewDate>{milliToDate(each.date)}</ListViewDate>
                        <Tooltip placement="topLeft" title={docNameFormatter(each.name)}>
                        
                          {(each.docId > 0 && each.uploadedByVC === true) ?


                            <ListViewUnderlineLink marginLeft='20px' data-test='grid-list' onClick={() => { this.downLoadFile(each.docId) }} >{docNameFormatter(each.name)}</ListViewUnderlineLink>

                            :


                            <ListViewUnderlineLink marginLeft='20px' href={each.link} target="_blank">{docNameFormatter(each.name)}</ListViewUnderlineLink>


                          }
                        </Tooltip>
                        {
                          ((moment(startDate, 'MM-DD-YYYY').diff(moment(each.date, 'MM-DD-YYYY'), 'days')) > 0 && (moment(startDate, 'MM-DD-YYYY').diff(moment(each.date, 'MM-DD-YYYY'), 'days')) <= 7) ?
                            <PrimaryIndicatorDocument>
                              new
                                     </PrimaryIndicatorDocument>
                            : ''
                        }
                      </ListComponentWrapper>
                    </Col>
                    <Col lg={{ span: 0 }} xs={{ span: 24 }}>
                      <ListMobileWrapper>
                        <FlexCenter>

                          <div>
                            <ListViewDate>{milliToDate(each.date)}</ListViewDate>
                            {
                              ((moment(startDate, 'MM-DD-YYYY').diff(moment(each.date, 'MM-DD-YYYY'), 'days')) > 0 && (moment(startDate, 'MM-DD-YYYY').diff(moment(each.date, 'MM-DD-YYYY'), 'days')) <= 7) ?
                                <PrimaryIndicatorDocument>
                                  new
                                     </PrimaryIndicatorDocument>
                                : ''
                            }
                            <DisplayFlex>
                              {(each.docId > 0 && each.uploadedByVC === true) ?


                                <ListViewUnderlineLink data-test= 'grid-list' onClick={() => { this.downLoadFile(each.docId) }} >{docNameFormatter(each.name)}</ListViewUnderlineLink>

                                :


                                <ListViewUnderlineLink href={each.link} target="_blank" >{docNameFormatter(each.name)}</ListViewUnderlineLink>


                              }

                              
                            </DisplayFlex>
                          </div>
                        </FlexCenter>
                      </ListMobileWrapper>
                    </Col>
                    {((index + 1) % 3 === 0) ? <SeparatorBorder /> : <div />}
                    {(index % 2 !== 0) ? <br /> : <div />}
                  </MainListWrapper>
                )
              }
              else {
                return false;
              }
            }
          }
          )
        }
      </Row>
    )
  }
}


ListViewDocument.propTypes = {
  arrayData: PropTypes.array,
  checkbox: PropTypes.bool,
  docVal: PropTypes.array,
  eachId: PropTypes.number,
  selectedFiles: PropTypes.array,
  selectedLinks: PropTypes.array,
  showMore: PropTypes.bool,
  checkBoxChange: PropTypes.func.isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  arrayData: state.getIn(["documentCentre", "docCentreData", "arrayData"]),
  selectedLinks: state.getIn(["documentCentre", "checkboxArray", "selected"]),
  selectedFiles: state.getIn(["documentCentre", "checkboxArray", "selectedFiles"])
});

export const mapDispatchToProps = dispatch => ({
  checkBoxChange: (val) => dispatch(checkBoxSelect(val)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ListViewDocument);

